export const appId = "7aa279d3-0190-45d5-afee-808b409b7729";
export const tenantId = "4184f669-16bc-4341-acb5-293df7d28643";
export const scopes = ["api://7aa279d3-0190-45d5-afee-808b409b7729/access_as_user"];
